import { Link } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";
import Seo from "@/components/base/Seo";

const values = [
  {
    icon: "ri-flashlight-fill",
    title: "秒开体验",
    desc: "采用网页直连与极速缓冲技术，无需安装插件，打开即可即点即看。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端适配",
    desc: "深度优化手机端体验，横竖屏自由切换，随时随地畅快观看。",
  },
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "优先提供高清画质，并按网络环境自动调节，减少卡顿与缓冲。",
  },
  {
    icon: "ri-list-check-2",
    title: "精选内容",
    desc: "严格筛选娱乐八卦、综艺热剧等优质内容，让好内容更容易被找到。",
  },
];

const testimonials = [
  {
    name: "阿杰",
    role: "通勤追剧党",
    text: "地铁上也能秒开看热剧剪辑，不用装东西这点真的太方便了。",
  },
  {
    name: "小鹿",
    role: "综艺爱好者",
    text: "分类很清楚，想找哪类综艺一眼就能定位，画质也流畅。",
  },
  {
    name: "老周",
    role: "晚间放松派",
    text: "下班回家刷刷搞笑日常，缓冲快不卡顿，是每天的解压时间。",
  },
];

export default function About() {
  return (
    <PageShell>
      <Seo
        title="关于我们 - 品牌介绍与发展理念 | 瓜趣视频"
        description="了解瓜趣视频：作为娱乐八卦资讯与热门视频聚合平台，我们坚持秒开播放、多端适配、精选内容与版权合规，努力让每个人都能轻松便捷地看到感兴趣的内容。"
        keywords="关于我们,瓜趣视频介绍,视频平台理念,秒开播放"
        canonical="https://gagplay6.github.io/about"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于瓜趣视频",
            url: "https://gagplay6.github.io/about",
            description: "瓜趣视频的品牌介绍与发展理念",
            inLanguage: "zh-CN",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://gagplay6.github.io/" },
              { "@type": "ListItem", position: 2, name: "关于我们", item: "https://gagplay6.github.io/about" },
            ],
          },
        ]}
      />

      <div className="container-x py-8">
        <nav className="flex items-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-600">
            首页
          </Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-700">关于我们</span>
        </nav>

        {/* 品牌介绍 */}
        <section className="mt-8 grid items-center gap-8 lg:grid-cols-2" aria-labelledby="brand-title">
          <div>
            <span className="chip bg-primary-100 text-primary-700">品牌介绍</span>
            <h1 id="brand-title" className="font-heading mt-4 text-2xl leading-tight text-foreground-950 md:text-4xl">
              让每一次点开，都能秒开畅看
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              瓜趣视频是一款专注提供秒开播放体验的娱乐八卦资讯与热门视频聚合平台。我们深知，追热点、看综艺、刷搞笑日常最重要的是"看得快、看得爽"。
              因此我们把"无需安装、网页直连、极速缓冲"作为产品的立身之本。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              从娱乐综艺到热剧剪辑，从明星八卦到生活妙招，我们把内容按分类整理得明明白白，配合清晰的搜索与筛选，让你再也不用东奔西走、来回折腾。
            </p>
            <Link to="/library" className="btn-primary mt-6">
              去视频库看看
            </Link>
          </div>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20bright%20team%20office%20with%20laptops%20and%20colorful%20screens%20showing%20entertainment%20videos%2C%20warm%20cream%20and%20coral%20illustration%20style%2C%20friendly%20energetic%20atmosphere%2C%20clean%20composition&width=1200&height=800&seq=about-guqu&orientation=landscape"
              alt="瓜趣视频团队工作场景插画"
              title="瓜趣视频 - 让好内容触手可及"
              className="h-full w-full object-cover"
            />
          </div>
        </section>

        {/* 定位与理念 */}
        <section className="mt-14 grid gap-8 lg:grid-cols-2" aria-labelledby="position-title">
          <div className="card-surface p-6">
            <h2 id="position-title" className="flex items-center gap-2 text-lg font-bold text-foreground-950">
              <i className="ri-compass-3-line text-primary-600" aria-hidden="true"></i>
              网站定位
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们定位为"随点随看的娱乐视频聚合平台"，核心解决两个问题：一是让用户不必折腾安装与等待，点开即播；二是把分散的热门内容按主题聚合，让"想看什么一眼就能找到"。
            </p>
          </div>
          <div className="card-surface p-6">
            <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
              <i className="ri-rocket-line text-accent-600" aria-hidden="true"></i>
              发展理念
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们相信，好的体验来自对细节的坚持。无论是缓冲速度、画质调节还是移动端适配，我们都希望做到"像喝水一样自然"。同时坚持合规运营，尊重版权与用户感受，让平台长期健康地陪伴大家。
            </p>
          </div>
        </section>

        {/* 核心价值 */}
        <section className="mt-14" aria-labelledby="value-title">
          <h2 id="value-title" className="section-title text-foreground-950">
            我们的坚持
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="card-surface p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${v.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 内容原则 */}
        <section className="mt-14 bg-background-100 p-6 md:p-8" aria-labelledby="principle-title">
          <h2 id="principle-title" className="section-title text-foreground-950">
            内容原则
          </h2>
          <div className="mt-5 grid gap-5 md:grid-cols-3">
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <i className="ri-shield-check-line text-2xl text-primary-500" aria-hidden="true"></i>
              <h3 className="mt-2 text-base font-bold text-foreground-950">真实可信</h3>
              <p className="mt-1.5 text-sm text-foreground-600">内容来源真实可溯，不做标题党，不夸大事实。</p>
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <i className="ri-copyright-line text-2xl text-accent-600" aria-hidden="true"></i>
              <h3 className="mt-2 text-base font-bold text-foreground-950">尊重版权</h3>
              <p className="mt-1.5 text-sm text-foreground-600">合规运营，尊重每一位创作者与版权所有者的权益。</p>
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <i className="ri-heart-3-line text-2xl text-secondary-500" aria-hidden="true"></i>
              <h3 className="mt-2 text-base font-bold text-foreground-950">用户友好</h3>
              <p className="mt-1.5 text-sm text-foreground-600">以用户的观看体验为先，持续根据反馈优化功能。</p>
            </div>
          </div>
        </section>

        {/* 用户口碑 */}
        <section className="mt-14" aria-labelledby="voice-title">
          <h2 id="voice-title" className="section-title text-foreground-950">
            听听大家怎么说
          </h2>
          <div className="mt-6 grid gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="card-surface p-5">
                <div className="flex gap-0.5 text-secondary-400">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* 联系方式 */}
        <section className="mt-14 bg-accent-100/60 p-6 md:p-8" aria-labelledby="about-contact">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
            <div>
              <h2 id="about-contact" className="text-lg font-bold text-foreground-950">
                想了解更多，或是有任何建议？
              </h2>
              <p className="mt-1 text-sm text-foreground-600">欢迎联系我们，我们很乐意倾听你的声音。</p>
            </div>
            <Link to="/contact" className="btn-primary">
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              联系我们
            </Link>
          </div>
        </section>
      </div>
    </PageShell>
  );
}